import { useDisciplineScheduleStore } from './schedule/store'
import { useDisciplineScheduleContext } from './discipline-schedule-context.hook'
import { getScheduleStartMinDate } from './discipline-schedule'

interface ModalDisciplineScheduleStartDateReturn {
  refStartDate: ComputedRef<string>
  refMinDate: ComputedRef<string>
  refIsDisabled: ComputedRef<boolean>
  setStartDate: (value: string) => void
  close: () => void
  back: () => void
  confirm: () => void
}

/** The first lesson's customer day: no earlier than 24 h after the customer's now. */
export const useModalDisciplineScheduleStartDate = (): ModalDisciplineScheduleStartDateReturn => {
  const store = useDisciplineScheduleStore()
  const { customerNow, close, back } = useDisciplineScheduleContext()

  const refStartDate = computed<string>(() => store.getStartDate)
  const refMinDate = computed<string>(() => getScheduleStartMinDate(customerNow()))
  const refIsDisabled = computed<boolean>(() => !store.getStartDate)

  const setStartDate = (value: string): void => {
    store.setStartDate(value)
  }

  return {
    refStartDate,
    refMinDate,
    refIsDisabled,
    setStartDate,
    close,
    back,
    confirm: () => store.nextStep(),
  }
}
